<template>
  <div class="chat-container">
    <button v-if="!isOpen" id="chat-button" @click="toggleChat" aria-label="Abrir chat">
      <i class="fas fa-headset"></i>
    </button>

    <transition name="fade">
      <div v-if="isOpen" id="chat-window">
        <div class="chat-header">
          <div>
            <strong>Suporte Técnico - Soul Tecnologia</strong>
            <div class="small"><i class="fas fa-circle text-success"></i> Online</div>
          </div>
          <button class="close text-white" @click="toggleChat">&times;</button>
        </div>

        <div class="chat-body" ref="chatContent">
          <div v-for="(msg, index) in mensagens" :key="index" @click="handleClick"
            :class="['msg', msg.type === 'bot' ? 'msg-in' : 'msg-out']">
            <div v-if="msg.text" v-html="msg.text"></div>
            <div v-if="msg.file" class="attachment-msg">
              <i class="fas fa-file-upload"></i> {{ msg.file }}
            </div>
          </div>
        </div>

        <div class="chat-footer">
          <form @submit.prevent="sendMessage">
            <div class="input-group">
              <div class="input-group-prepend">
                <button type="button" class="btn btn-light border-0" @click="triggerFile">
                  <i class="fas fa-paperclip text-muted"></i>
                </button>
              </div>

              <input type="file" ref="fileInput" @change="anexarArquivo" style="display: none" :disabled="input_text">

              <input v-model="newText" type="text" class="form-control border-0 bg-light" placeholder="Escreva aqui..."
                :disabled="input_text">

              <div class="input-group-append">
                <button class="btn btn-primary" type="submit">
                  <i class="fas fa-paper-plane"></i>
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import api from '@/api';
import { handleRequestErrors } from '@/handleErrors';

export default {
  name: 'ChatSuporte',
  data() {
    return {
      isOpen: false,
      newText: '',
      mensagens: [],
      start_support: false,
      end_support: false,
      search_client_document: false,
      matters: false,
      status_protocol: false,
      question_client: false,
      generate_protocol: false,
      search_protocol: false,
      register_new_message: false,
      input_text: true,
      clientId: '',
      subject: 'Diversos',
      polling: null,
      searchForNewMessages: false,
      userId: ''
    };
  },
  beforeUnmount() {
    clearInterval(this.polling);
  },
  methods: {
    injectMessage(type, text) {
      this.mensagens.push({ type: type, text: text });
    },
    messageWellcome() {
      if (this.start_support) {
        this.start_support = true;
        this.injectMessage('bot', '<p class="text-justify">Olá! Seja bem-vindo(a) ao nosso suporte. Sempre que desejar encerrar a conversa, basta digitar a palavra <strong>encerrar</strong> ou <strong>menu</strong> para voltar ao menu inicial.<p>');
        this.injectMessage('bot', '<p class="text-justify">Para iniciarmos, preciso que me informe seu documento (<strong>CPF ou CNPJ</strong>) de acesso para que possamos identificá-lo.</p>');
        this.input_text = false;
        this.search_client_document = true;
        this.start_support = false;
      }
    },
    messageMatters() {
      setTimeout(() => {
        this.injectMessage('bot', '<button class="btn btn-default btn-sm technical_support">Suporte Técnico</button>');
        this.injectMessage('bot', '<button class="btn btn-default btn-sm status_protocol">Status protocolo</button>');
        this.injectMessage('bot', '<button class="btn btn-default btn-sm general_questions">Dúvidas Gerais</button>');
        this.injectMessage('bot', '<button class="btn btn-default btn-sm stop_chat">Encerrar chamada</button>');
      }, 2100);

    },
    messageUserLogged() {
      const name = localStorage.getItem('name');
      setTimeout(() => {
        this.injectMessage('bot', '<p class="text-justify">Olá ' + name + ', tudo bem? Como podemos te ajudar hoje?</p>');
        this.scrollToBottom();
      }, 1000);
      this.loading = false;

    },
    messageSearchDocument() {
      setTimeout(() => {
        this.injectMessage('bot', '<p class="text-justify">Por gentileza, informe seu <strong>CNPJ</strong>, caso seja Pessa Júrica, ou seu <strong>CPF</strong>, se Pessoa Física.</p>');
        this.scrollToBottom();
      }, 2000);
      this.loading = false;

    },
    messageHelpToday() {
      setTimeout(() => {
        this.injectMessage('bot', '<p class="text-justify">Entendi. Como podemos ajudá-lo(a) hoje?</p>');
        this.scrollToBottom();
      }, 2000);


    },
    messageStatusProtocol() {

      setTimeout(() => {
        this.injectMessage('bot', '<p class="text-justify">Por gentileza, informe o número do protocolo. Ele segue o seguinte padrão: <strong>xxxx-xxxxxx</strong></p>');
        this.scrollToBottom();
      }, 2000);

    },
    messageProtocolGegenerate(protocol, date, hour) {

      setTimeout(() => {
        this.injectMessage('bot', '<p class="text-justify">Sua mensagem já está conosco e em breve alguém do nosso time irá respondê-lo(a), tudo bem? Seu nº de protocolo é: <strong>' + protocol + '</strong> aberto em ' + date + ' às ' + hour + '</p>');
        this.scrollToBottom();
      }, 2000);

    },

    loadNewMessages() {
      const protocol = localStorage.getItem('protocol_help_desk');
      this.polling = setInterval(() => {
        if (this.searchForNewMessages) {
          this.searchProtocol(protocol);
        }

      }, 100000);
    },
    handleClick(e) {
      const technical_support = e.target.closest(".technical_support");
      const status_protocol = e.target.closest(".status_protocol");
      const general_questions = e.target.closest(".general_questions");
      const stop_chat = e.target.closest(".stop_chat");

      if (technical_support) {
        this.injectMessage('user', '<p>Suporte Técnico</p>');
        this.input_text = false;
        this.messageHelpToday();
        this.question_client = true;
        this.generate_protocol = true;
        this.search_protocol = false;
        this.matters = false;
        this.subject = 'Suporte Técnico';
      } else if (status_protocol) {
        this.injectMessage('user', '<p>Status protocolo</p>');
        this.input_text = false;
        this.messageStatusProtocol();
        this.question_client = true;
        this.generate_protocol = false;
        this.search_protocol = true;
        this.matters = false;
        this.subject = 'Consultar protocolo';
      } else if (general_questions) {
        this.injectMessage('user', '<p>Dúvidas Gerais</p>');
        this.input_text = false;
        this.messageHelpToday();
        this.question_client = true;
        this.generate_protocol = true;
        this.search_protocol = false;
        this.matters = false;
        this.subject = 'Dúvidas gerais';
      } else if (stop_chat) {
        this.injectMessage('user', '<p>Encerrar chamada</p>');
        this.injectMessage('bot', '<p class="text-justify">Seu atendimento foi encerrado. Agradecemos pelo contato.</p>');
        this.input_text = false;
        this.false = true;
        this.generate_protocol = false;
        this.search_protocol = false;
        this.register_new_message = false;
        this.matters = false;
      }

      this.scrollToBottom();

    },
    converterLinks(text) {
      const regexUrl = /((https?:\/\/)|(www\.))[^\s]+/g;

      return text.replace(regexUrl, (url) => {
        let href = url;
        if (url.toLowerCase().startsWith('www.')) {
          href = 'http://' + url;
        }

        return `<a href="${href}" target="_blank" rel="noopener noreferrer">${url}</a>`;
      });
    },
    toggleChat() {
      this.isOpen = !this.isOpen;
      this.searchForNewMessages = !this.searchForNewMessages;
      //Verifica se existe algum protocolo em aberto
      const protocol = localStorage.getItem('protocol_help_desk');
      if (protocol != null) {
        this.searchProtocol(protocol);
        this.loadNewMessages();
        this.register_new_message = true;
        this.input_text = false;
      } else {
        //Verifica se existe um user_id já setado. Se sim, prosseguir para perguntas do que deseja. Do contrário, dar boas-vindas
        const user_id = localStorage.getItem('user_id');
        if (user_id != null) {
          if (this.mensagens.length <= 0) {
            this.start_support = false;
            this.matters = true;
            this.messageUserLogged();
            this.messageMatters();
          }

        } else {
          if (this.mensagens.length <= 0) {
            this.start_support = true;
            this.messageWellcome();
          }
        }

      }
      if (this.isOpen) {
        this.scrollToBottom();
      }
    },

    stopHelpDesk() {
      this.stopTicket();

    },

    searchDocumentUser(document) {
      //Busca informação banco de dados
      api.get('/search-user/' + document)
        .then((response) => {
          this.loading = false;
          this.search_client_document = false;
          this.matters = true;
          this.userId = response.data.user;
          localStorage.setItem('user_id', response.data.user);
          localStorage.setItem('name', response.data.name);
          this.mensagens = [];
          this.injectMessage('bot', '<p class="text-justify">Encontramos o seu cadastro. Agora, por gentileza, poderia escolher qual assunto deseja tratar?</p>');
          this.messageMatters();
          this.input_text = true;
          this.scrollToBottom();
        }).catch(error => {
          this.loading = false;
          if (error.status == 404) {
            this.injectMessage('bot', 'Desculpe-nos, mas não conseguimos identificar seu cadastro. Por gentileza, poderia verificar se informou corretamente o documento?');
          } else if (error.status == 429) {
            this.injectMessage('bot', 'Desculpe-nos, mas estamos indisponíveis no momento. Por gentileza, tente novamente em instantes. Cód 429');
          } else if (error.status == 500) {
            this.injectMessage('bot', 'Desculpe-nos, mas não estamos conseguindo verificar seu registro no momento. Por favor, tente novamente em instantes. Cód 500');
          }
          this.scrollToBottom();
        })
    },

    searchProtocol(protocol) {
      //Busca informação banco de dados
      api.get('/search-protocol/' + protocol)
        .then((response) => {
          this.loading = false;
          if (response.data.data.status == 'Finalizado') {
            this.mensagens = [];
            this.injectMessage('bot', '<p class="text-justify">Olá! O protocolo de nº <strong>' + protocol + '</strong> foi encerrado. Caso precise, pode abrir um novo chamado.</p>');
            localStorage.removeItem('protocol_help_desk');
            this.start_support = false;
            this.this.search_client_document = true;
            this.messageSearchDocument();
            this.input_text = false;
            return;
          }
          if (response.data.data.messages.length <= 1 && this.mensagens.length == 0) {
            this.injectMessage('bot', '<p class="text-justify">Olá! Nosso time ainda está analisando sua mensagem e responderá o protocolo de nº <strong>' + protocol + '</strong> o mais breve possível.</p>');
          } else {
            this.mensagens = [];
            let messages = response.data.data.messages;
            messages.forEach(message => {
              this.injectMessage(message.agent, '<p class="text-justify">' + this.converterLinks(message.message) + '</p>');
            });
            this.register_new_message = true;
            this.search_client_document = false;
            this.matters = false;
            this.status_protocol = false;
            this.question_client = false;
            this.generate_protocol = false;
            this.search_protocol = false;
          }
          localStorage.setItem('protocol_help_desk', protocol);
          this.scrollToBottom();
        }).catch(error => {
          this.loading = false;
          if (error.status == 404) {
            this.injectMessage('bot', 'Desculpe-nos, mas não conseguimos identificar  o protocolo. Por gentileza, poderia verificar se informou corretamente os números, no padrão <strong>xxxx-xxxxxx</strong>');
          } else if (error.status == 429) {
            this.injectMessage('bot', 'Desculpe-nos, mas estamos indisponíveis no momento. Por gentileza, tente novamente em instantes. Cód 429');
          } else if (error.status == 500) {
            this.injectMessage('bot', 'Desculpe-nos, mas não estamos conseguindo verificar seu registro no momento. Por favor, tente novamente em instantes. Cód 500');
          }
          this.scrollToBottom();
        })
    },

    createNumberProtocol(message) {
      api.get('/create-number-protocol', {
        params: {
          'subject': this.subject,
          'type': 'text',
          'user_id': localStorage.getItem('user_id'),
          'message': message
        }
      })
        .then((response) => {
          this.loading = false;
          localStorage.setItem('protocol_help_desk', response.data.data.protocol);
          const number_protocol = response.data.data.protocol;
          const date_start_protocol = response.data.data.created_at_date;
          const hour_start_protocol = response.data.data.created_at_hour;
          this.mensagens = [];
          this.injectMessage('user', message);
          this.messageProtocolGegenerate(number_protocol, date_start_protocol, hour_start_protocol);
          this.loadNewMessages();
          this.generate_protocol = false;
          this.matters = true;
          this.register_new_message = true;
          this.input_text = false;
          this.scrollToBottom();
        }).catch(error => {
          this.loading = false;
          if (error.status == 404) {
            this.injectMessage('bot', 'Desculpe-nos, mas não conseguimos identificar seu cadastro. Por gentileza, poderia verificar se informou corretamente o documento?');
          } else if (error.status == 429) {
            this.injectMessage('bot', 'Desculpe-nos, mas estamos indisponíveis no momento. Por gentileza, tente novamente em instantes. Cód 429');
          } else if (error.status == 500) {
            this.injectMessage('bot', 'Desculpe-nos, mas não estamos conseguindo verificar seu registro no momento. Por favor, tente novamente em instantes. Cód 500');
          }
          this.scrollToBottom();
        })
    },
    stopTicket() {
      const protocol = localStorage.getItem('protocol_help_desk');
      this.$confirm(
        {
          message: 'Deseja encerrar o suporte?',
          button: {
            no: 'Não',
            yes: 'Sim'
          },

          callback: confirm => {
            if (confirm) {
              api.post('/close-protocol/' + protocol)
                .then(() => {
                  this.isLoading = false;
                  this.$notify({
                    title: "Sucesso",
                    text: "Suporte encerrado com sucesso",
                    type: 'success'
                  });
                  this.loading = false;

                  this.novoText = '';
                  this.mensagens = [];
                  localStorage.removeItem('user_id');
                  localStorage.removeItem('name');
                  localStorage.removeItem('protocol_help_desk');
                  this.injectMessage('bot', '<p class="text-justify">Seu atendimento foi encerrado. Agradecemos pelo contato. E qualquer dúvida, estamos à disposição.</p>');
                  this.search_client_document = false;
                  this.end_support = false;
                  this.start_support = true;
                  setTimeout(() => {
                    this.isOpen = false;
                  }, 5000);
                }).catch(error => {
                  this.isLoading = false;
                  handleRequestErrors(error.status);
                })
            }
          }
        }
      )
    },

    registerMessage(message_send) {
      let message = message_send.trim();
      api.post('/register-message/' + localStorage.getItem('protocol_help_desk'), {
        'type': 'text',
        'message': message,
        'agent': 'user'

      })
        .then(() => {
          this.newText = '';
          this.scrollToBottom();
        }).catch(error => {
          this.loading = false;
          if (error.status == 404) {
            this.injectMessage('bot', 'Desculpe-nos, mas não conseguimos identificar seu cadastro. Por gentileza, poderia verificar se informou corretamente o documento?');
          } else if (error.status == 429) {
            this.injectMessage('bot', 'Desculpe-nos, mas estamos indisponíveis no momento. Por gentileza, tente novamente em instantes. Cód 429');
          } else if (error.status == 500) {
            this.injectMessage('bot', 'Desculpe-nos, mas não estamos conseguindo enviar a mensagem no momento. Por favor, tente novamente em instantes. Cód 500');
          }
          this.scrollToBottom();
        })
    },

    sendMessage() {
      if (this.newText.trim() === '') return;

      this.injectMessage('user', this.newText);
      this.scrollToBottom();
      const message_send = this.newText.toLocaleLowerCase();
      this.newText = '';
      // Simulação de resposta
      setTimeout(() => {
        if (this.novoText != '') {
          if (this.end_support) {
            this.start_support = true;
            this.end_support = false;
            this.loading = false;
            this.novoText = '';
            return;
          }
          if (message_send == 'encerrar') {
            this.stopHelpDesk();
            return;
          } else if (message_send == 'menu') {
            this.loading = false;
            if (this.userId != '') {
              this.messageMatters();
            } else {
              this.start_support = true;
              this.end_support = false;
              this.search_client_document = false;
              this.matters = false;
              this.messageWellcome();
              this.input_text = false;
            }
            return;
          }

          if (this.start_support) {
            this.messageSearchDocument();
            this.start_support = false;
            this.search_client_document = true;
          } else if (this.search_client_document) {
            this.searchDocumentUser(message_send);
          } else if (this.matters && this.question_client && !this.generate_protocol) {
            this.loading = false;
            this.injectMessage('bot', '<p class="text-justify">Por gentileza, poderia escolher qual assunto deseja tratar?</p>');
            this.messageMatters();
          } else if (this.generate_protocol && this.question_client && !this.register_new_message) {
            this.createNumberProtocol(message_send);
          } else if (this.search_protocol) {
            this.searchProtocol(message_send);
          } else if (this.register_new_message) {
            this.registerMessage(message_send);
          }

        }
        this.scrollToBottom();
      }, 2000);

    },
    triggerFile() {
      this.$refs.fileInput.click();
    },
    anexarArquivo(event) {
      const file = event.target.files[0];
      if (file) {
        this.mensagens.push({
          type: 'user',
          file: file.name
        });
        this.scrollToBottom();
      }
    },
    scrollToBottom() {
      // O nextTick garante que o DOM foi atualizado antes de rolar
      this.$nextTick(() => {
        const container = this.$refs.chatContent;
        if (container) {
          container.scrollTop = container.scrollHeight;
        }
      });
    }
  }
};
</script>

<style scoped>
/* Copie o CSS anterior aqui e adicione a animação de transição do Vue */
#chat-button {
  position: fixed;
  bottom: 20px;
  right: 20px;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background-color: #042F5F;
  color: white;
  border: none;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
  z-index: 1050;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
}

#chat-window {
  position: fixed;
  bottom: 90px;
  right: 20px;
  width: 380px;
  height: 700px;
  background-color: white;
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
  z-index: 1050;
  overflow: hidden;
}

.chat-header {
  background: #042F5F;
  color: white;
  padding: 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.chat-body {
  flex: 1;
  padding: 15px;
  overflow-y: auto;
  background-color: #f8f9fa;
  display: flex;
  flex-direction: column;
  scroll-behavior: smooth;
}

.msg {
  margin-bottom: 12px;
  padding: 10px 15px;
  border-radius: 18px;
  font-size: 14px;
  max-width: 85%;
}

.msg-in {
  background-color: #fff;
  align-self: flex-start;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);
}

.msg-out {
  background-color: #042F5F;
  color: white;
  align-self: flex-end;
}

.attachment-msg {
  font-size: 12px;
  font-style: italic;
  border: 1px dashed #ccc;
  padding: 5px;
  margin-top: 5px;
  border-radius: 5px;
}

.chat-footer {
  padding: 10px;
  border-top: 1px solid #eee;
  background: white;
}

/* Transição do Vue */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s, transform 0.3s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
  transform: translateY(20px);
}

@media (max-width: 576px) {
  #chat-window {
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    border-radius: 0;
  }

  .chat-footer {
    padding-bottom: 10px;
  }
}
</style>